import { useAtomValue } from 'jotai';
import { GridApi, IRowNode } from 'ag-grid-community';
import { useCallback, useEffect } from 'react';
import { pfGridApiAtom } from '../components/OverviewTable/PfState';
import { GCChartSelectedCompanyIdAtom } from '../state/ViewStateJ';

function getCompanyRowNode(selectedCompanyId: number, gridApi: GridApi) {
  let rowNode: IRowNode | null = null;
  gridApi.forEachNode((node) => {
    if (node.data && node.data.companyId === selectedCompanyId) {
      rowNode = node;
    }
  });
  return rowNode;
}

export const useScrollToSelectedCompany = () => {
  const selectedCompanyId = useAtomValue(GCChartSelectedCompanyIdAtom);
  const gridApi = useAtomValue(pfGridApiAtom);

  const flashSelectedCell = useCallback(() => {
    if (!gridApi) {
      return;
    }

    const rowNode = getCompanyRowNode(selectedCompanyId, gridApi);
    if (rowNode) {
      gridApi.flashCells({ rowNodes: [rowNode!], flashDuration: 2500 });
      gridApi.removeEventListener('bodyScrollEnd', flashSelectedCell);
    }
  }, [gridApi, selectedCompanyId]);

  useEffect(() => {
    if (selectedCompanyId !== -1 && gridApi) {
      const rowNode = getCompanyRowNode(selectedCompanyId, gridApi);
      if (rowNode) {
        gridApi.ensureIndexVisible((rowNode as IRowNode).rowIndex!, 'top');
        gridApi.addEventListener('bodyScrollEnd', flashSelectedCell);
      }
    }

    return () => {
      gridApi?.removeEventListener('bodyScrollEnd', flashSelectedCell);
    };
  }, [selectedCompanyId, gridApi, flashSelectedCell]);
};
